enum SidebarContentType {
  Home = 'home',
  Workspace = 'workspace',
  Playground = 'playground',
  Draft = 'draft',
  MyWorkspaces = 'myWorkspaces',
  AnalyticsDashboard = 'AnalyticsDashboard',
  None = 'None',
}

export { SidebarContentType };
